// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';


// utilities
import cx from 'classnames';

// components
import Modal from '../../components/r_Modal';
import ModalX from '../../svgs/ModalX';

import DropDownMenu from '../../components/c_DropDownMenu';

export default class cardModal extends Component{

  onChange(event, value){
    //this.props.statusDropdown.value = value;
    this.props.onChange(value);
  }


  render() {
    const childrenWithProps = React.Children.map(this.props.children,
        (child) => React.cloneElement(child, {})
    );
    return (
      <Modal>
        <div className='card-modal transition-block-form'>
            {childrenWithProps}
        </div>
      </Modal>
    );



  }

}



// WEBPACK FOOTER //
// ./shared/common/components/с_cardModal/index.js